import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, renderList as _renderList, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8714e068"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Return to Payment Accounts ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Payment Account", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "credit_card" }, "Credit Card", -1))
const _hoisted_9 = {
  key: 0,
  value: "ach"
}
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name", -1))
const _hoisted_12 = { class: "form-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name", -1))
const _hoisted_14 = { class: "form-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account number", -1))
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account number confirmation", -1))
const _hoisted_18 = { class: "form-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Routing Number", -1))
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account Type", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PERSONAL_CHECKING" }, "Personal Checking", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PERSONAL_SAVINGS" }, "Personal Savings", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BUSINESS_CHECKING" }, "Business Checking", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BUSINESS_SAVINGS" }, "Business Savings", -1))
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "form-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Card Type", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Card Number", -1))
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expiration Month/Year", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "form-field" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CVV", -1))
const _hoisted_38 = { class: "form-field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address", -1))
const _hoisted_40 = { class: "form-field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City", -1))
const _hoisted_42 = { class: "form-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State/Province", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select State/Province", -1))
const _hoisted_45 = { class: "form-field" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Zip", -1))
const _hoisted_47 = { class: "form-field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Country", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select Country", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Active Payment Account", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Select if you would like this to be the active payment account used for recurring billing. ", -1))
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Creating")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Create")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Updating ")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Payment Account ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Cancel ")

import api from "@virgodev/bazaar/functions/api";
import { ref, onMounted } from "vue";
import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";
import { storeToRefs } from "pinia";
import { useStore } from "../store";
import moment from "moment";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  paymentAccountId: {
    type: Number,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const status = ref("loading");
const store = useStore();
const { userData } = storeToRefs(store);
const urlForAuth = ref("");
const errorPaymentMessage = ref("");
const tokenFee = ref();
const convenienceFeeSetting =
  userData.value.chosenFacility.require_convenience_fee;
const achNotAccepted = userData.value.chosenFacility.ach_not_accepted;
const facility = ref();
const cardTypes = ref();
const expirationMonth = ref();
const expirationYear = ref();
const formFields = ref({
  account_number: ref(),
  account_number_confirmation: ref(),
  address: ref(),
  card_expires_on: ref(),
  card_number: ref(),
  card_type: ref(),
  city: ref(),
  first_name: ref(),
  kind: ref(),
  last_name: ref(),
  routing_number: ref(),
  state: ref(null),
  zip: ref(),
  country: ref(null),
  active: ref(false),
  verification_value: ref(),
});
const states = [
  "AL",
  "AB",
  "AK",
  "AS",
  "AZ",
  "AR",
  "BC",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "MB",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "NB",
  "NL",
  "NS",
  "NU",
  "NT",
  "MP",
  "OH",
  "OK",
  "ON",
  "OR",
  "PA",
  "PEI",
  "PR",
  "QC",
  "RI",
  "SC",
  "SD",
  "SK",
  "TN",
  "TX",
  "TT",
  "VI",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "YT",
];
const countryList = [
  "United States of America",
  "Canada",
  "United Kingdom",
  "Australia",
  "Austria",
  "Belgium",
  "Brazil",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Latvia",
  "Lituania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "New Zealand",
  "Poland",
  "Portugal",
  "Romania",
  "Russian Federation",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Spain",
  "Sweden",
  "Switzerland",
  "Thailand",
  "United Arab Emirates (the)",
];
const months = ref();
const years = ref();
const accountType = ref();
const customer = ref();
async function getFacility() {
  errors.value = "";
  const response = await api({
    url: `facility/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    facility.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
// const router = useRouter();
onMounted(async () => {
  await getFacility();
  moment.locale("en"); // sets words language (optional if current locale is to be used)
  months.value = moment.months(); // returns a list of months in the current locale (January, February, etc.)
  let current_year = moment().year();
  let end_year = Number(current_year) + 20;
  let year_list = [];
  for (let i = Number(current_year); i <= end_year; i++) {
    year_list.push(i);
  }
  years.value = year_list;
  cardTypes.value = facility.value.enabled_credit_card_types;
  if (props.paymentAccountId) {
    await getPaymentAccounts();
  } else {
    await getCustomer();
  }
  status.value = "loaded";
});
const errors = ref("");

async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    let name = customer.value.name.split(" ");
    formFields.value.first_name = name[0];
    formFields.value.last_name = name[name.length - 1];
    formFields.value.address = customer.value.address;
    formFields.value.city = customer.value.city;
    formFields.value.state = customer.value.state;
    formFields.value.zip = customer.value.zip;
    formFields.value.country = customer.value.country;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getConvenienceFeeToken() {
  let method;
  let payment_information;
  if (formFields.value.kind == "credit_card") {
    method = formFields.value;
    let card_exp = method.card_expires_on.split("-");
    if (card_exp[1].length == 1) {
      card_exp[1] = "0" + card_exp[1];
    }
    payment_information = {
      card: {
        name: customer.value.name,
        number: method.card_number,
        expMonth: card_exp[1],
        address: {
          postalCode: method.zip,
          country: "US",
          region: method.state,
          streetAddress: method.address,
          city: method.city,
        },
        expYear: card_exp[0],
        cvc: method.verification_value,
      },
    };
  } else if (formFields.value.kind == "ach") {
    method = formFields.value;
    let phone = "";
    if (customer.value.phone) {
      phone = customer.value.phone.substring(2);
    } else if (customer.value.cell_phone) {
      phone = customer.value.cell_phone.substring(2);
    }
    payment_information = {
      bankAccount: {
        name: customer.value.name,
        accountNumber: method.account_number,
        accountType: accountType.value,
        phone: phone,
        routingNumber: method.routing_number,
      },
    };
  }
  if (method) {
    const json = JSON.parse(JSON.stringify(payment_information));
    let url = `generate_token_convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      tokenFee.value = responseData.body.value;
    }
  }
}

async function convenienceFee() {
  await getConvenienceFeeToken();
  const json = JSON.parse(
    JSON.stringify({
      token: tokenFee.value,
      payment_method: formFields.value.kind,
      tenant: {
        name: customer.value.name,
        id: props.customerId,
      },
    })
  );

  let url = `quickbooks_save_payment_type/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("successful create payment type");
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function quickBooksAuthCheck() {
  let url = `auth_check/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "GET",
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.url) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      urlForAuth.value = responseData.body.url;
    } else {
      await convenienceFee();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function submitForm() {
  if (formFields.value.kind == "credit_card") {
    formFields.value.card_expires_on =
      expirationYear.value + "-" + expirationMonth.value + "-01";
  }
  // formFields.value.active = formFields.value.active.toString();
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `payment_accounts/?facilityId=${props.facilityId}`;
  let method: "POST" | "PATCH" = "POST";

  if (props.paymentAccountId) {
    url += `&id=${props.paymentAccountId}/`;
    method = "PATCH";
    if (!json.verification_value) {
      delete json.verification_value;
    }
    if (json.card_number[0] == "X") {
      delete json.card_number;
    }
  } else if (props.customerId) {
    url += `&id=${props.customerId}/`;
  }

  const responseData = await api({
    url,
    method,
    json,
  });
  formSubmitting.value = false;

  if ([200, 201].includes(responseData.status)) {
    if (convenienceFeeSetting) {
      await quickBooksAuthCheck();
    }
    router.push({
      name: "payment_details",
      params: {
        customerId: props.customerId,
        customerName: props.customerName,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.paymentAccountId}&single=true&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let state = response.body.state;
    let country = response.body.country;
    if (state && !states.includes(state)) {
      states.push(state);
    }
    if (country && !countryList.includes(country)) {
      countryList.push(country);
    }
    formFields.value = response.body;
    formFields.value.card_number = response.body.masked_card_number;
    expirationMonth.value = moment(response.body.card_expires_on).month() + 1;
    expirationYear.value = moment(response.body.card_expires_on).year();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    _createVNode(_component_RouterLink, {
      to: {
      name: 'payment_details',
      params: {
        customerId: __props.customerId,
        customerName: __props.customerName,
        facilityId: __props.facilityId,
      },
    }
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_3,
    _createVNode(OutstandingFeeBanner, {
      "facility-id": __props.facilityId,
      "customer-id": __props.customerId
    }, null, 8, ["facility-id", "customer-id"]),
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
          _createElementVNode("form", {
            class: "well",
            onSubmit: _withModifiers(submitForm, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.kind) = $event)),
                class: "form-select",
                required: ""
              }, [
                _hoisted_8,
                (!_unref(achNotAccepted))
                  ? (_openBlock(), _createElementBlock("option", _hoisted_9, "ACH"))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vModelSelect, formFields.value.kind]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.first_name) = $event)),
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, formFields.value.first_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.last_name) = $event)),
                type: "text",
                required: ""
              }, null, 512), [
                [_vModelText, formFields.value.last_name]
              ])
            ]),
            (formFields.value.kind == 'ach')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.account_number) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.account_number]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.account_number_confirmation) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.account_number_confirmation]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.routing_number) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.routing_number]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((accountType).value = $event)),
                      class: "form-select",
                      required: ""
                    }, _hoisted_26, 512), [
                      [_vModelSelect, accountType.value]
                    ])
                  ])
                ], 64))
              : (formFields.value.kind == 'credit_card')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.card_type) = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardTypes.value, (card) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: card + 'card',
                            value: card
                          }, _toDisplayString(card), 9, _hoisted_29))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formFields.value.card_type]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.card_number) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.card_number]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((expirationMonth).value = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: month,
                            value: index + 1
                          }, _toDisplayString(index + 1) + " - " + _toDisplayString(month), 9, _hoisted_34))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, expirationMonth.value]
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((expirationYear).value = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year + 'year',
                            value: year
                          }, _toDisplayString(year), 9, _hoisted_35))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, expirationYear.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.verification_value) = $event)),
                        type: "text"
                      }, null, 512), [
                        [_vModelText, formFields.value.verification_value]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.address) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, formFields.value.address]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formFields.value.city) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, formFields.value.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.state) = $event)),
                class: "form-select"
              }, [
                _hoisted_44,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                  return _createElementVNode("option", { key: state }, _toDisplayString(state), 1)
                }), 64))
              ], 512), [
                [_vModelSelect, formFields.value.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFields.value.zip) = $event)),
                type: "text"
              }, null, 512), [
                [_vModelText, formFields.value.zip]
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.country) = $event)),
                class: "form-select"
              }, [
                _hoisted_49,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countryList, (country) => {
                  return _createElementVNode("option", { key: country }, _toDisplayString(country), 1)
                }), 64))
              ], 512), [
                [_vModelSelect, formFields.value.country]
              ])
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.active) = $event)),
                class: "form-check-input",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, formFields.value.active]
              ]),
              _hoisted_50,
              _hoisted_51,
              _hoisted_52
            ]),
            _createElementVNode("button", {
              class: "btn",
              type: "submit",
              disabled: formSubmitting.value
            }, [
              (!__props.paymentAccountId)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (formSubmitting.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_54
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_55
                        ], 64))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (formSubmitting.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_56
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_57
                        ], 64))
                  ], 64)),
              _hoisted_58
            ], 8, _hoisted_53),
            _createVNode(_component_RouterLink, {
              class: "btn",
              to: {
          name: 'payment_details',
          params: {
            customerId: __props.customerId,
            customerName: __props.customerName,
            facilityId: __props.facilityId,
          },
        }
            }, {
              default: _withCtx(() => [
                _hoisted_59
              ]),
              _: 1
            }, 8, ["to"])
          ], 40, _hoisted_5)
        ])),
    (formErrors.value.non_field_errors !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 2,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[18] || (_cache[18] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Please check the card number. " + _toDisplayString(formErrors.value.non_field_errors[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})